import { defineStore } from 'pinia';
import { PurchaseOrderDto, PurchaseOrderListItemDto } from '@containex/portal-backend-dto';
import { computed, ref } from 'vue';

export const useOrderStore = defineStore('purchase-order', () => {
    const orders = ref<PurchaseOrderListItemDto[]>([]);
    const order = ref<PurchaseOrderDto | null>(null);
    const orderCompletedDialogIsVisible = ref(false);
    const searchQuery = ref('');

    const filteredOrders = computed(() => {
        const query = searchQuery.value.toLowerCase().trim();
        if (query === '') {
            return orders.value;
        }
        return orders.value.filter(
            (o) =>
                o.id.toLowerCase().includes(query) ||
                o.companyName.toLowerCase().includes(query) ||
                o.originalOrderId.toLowerCase().includes(query) ||
                o.serialNumbers.some((sn) => sn.toLowerCase().includes(query))
        );
    });

    return {
        orders: computed(() => orders.value),
        filteredOrders,
        order: computed(() => order.value),
        orderCompletedDialogIsVisible: computed(() => orderCompletedDialogIsVisible.value),
        searchQuery: computed(() => searchQuery.value),
        setOrders(data: PurchaseOrderListItemDto[]): void {
            orders.value = data;
        },
        setOrder(data: PurchaseOrderDto | null): void {
            order.value = data;
        },
        setOrderCompletedDialogIsVisible(isVisible: boolean): void {
            orderCompletedDialogIsVisible.value = isVisible;
        },
        setSearchQuery(query: string): void {
            searchQuery.value = query;
        },
    };
});
